import { message } from "antd";
import { I18n } from "react-redux-i18n";

import ContractRequests from "app/api/contract";
import { handleGenericApiError } from "app/api/error";
import { base64ToBlob } from "app/utils/file";

import { addLoading, removeLoading } from "./loading";

export const ACTION_SAVE_CONTRACTS = "contract:ACTION_SAVE_CONTRACTS";
export const ACTION_SAVE_CONTRACT = "contract:ACTION_SAVE_CONTRACT";
export const ACTION_SAVE_CONTRACTS_CONSOLIDATED =
  "contract:ACTION_SAVE_CONTRACTS_CONSOLIDATED";
export const ACTION_STATUS_PDF = "contract:ACTION_STATUS_PDF";

export const fetchContracts = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await ContractRequests.fetchContracts(params);
    dispatch({ type: ACTION_SAVE_CONTRACTS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchAllContracts = params => async () => {
  try {
    return await ContractRequests.fetchContracts(params);
  } catch (err) {
    handleGenericApiError(err);
  }
};

export const downloadPreContractsConsolidated = params => async () => {
  if (
    params.searchParameter?.InitialContractDate &&
    params.searchParameter?.EndContractDate
  ) {
    var initialDate = params.searchParameter?.InitialContractDate.split(" ");
    var endDate = params.searchParameter?.EndContractDate.split(" ");
    initialDate = new Date(initialDate[0]);
    endDate = new Date(endDate[0]);
    var totalDaysDiff = Math.abs(endDate - initialDate) / (1000 * 60 * 60 * 24);
    if (totalDaysDiff < 185) {
      try {
        const response =
          await ContractRequests.downloadPreContractsConsolidated(
            params.searchParameter
          );
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", "consolidados_contratos.csv");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        handleGenericApiError(err);
      }
    } else {
      message.info(I18n.t("errors.DATE_FILTER_PERIOD_INVALID"));
      return false;
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};

export const fetchContractsConsolidated = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await ContractRequests.fetchContractsConsolidated(params);
    dispatch({ type: ACTION_SAVE_CONTRACTS_CONSOLIDATED, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const downloadContract = id => async () => {
  try {
    const response = await ContractRequests.downloadContract(id);
    const link = document.createElement("a");
    link.href = response.data;
    link.setAttribute("download", "contrato.pdf"); //
    document.body.appendChild(link);
    link.click();
  } catch (err) {
    handleGenericApiError(err);
  }
};

export const downloadEvidence = id => async () => {
  try {
    const response = await ContractRequests.downloadEvidence(id);
    const link = document.createElement("a");
    link.href = response.data;
    link.setAttribute("download", "contrato.pdf"); //
    document.body.appendChild(link);
    link.click();
  } catch (err) {
    handleGenericApiError(err);
  }
};

export const fetchContractById = (id, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await ContractRequests.fetchContractById(id);
    dispatch({ type: ACTION_SAVE_CONTRACT, payload: data });
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
    return "error";
  } finally {
    dispatch(removeLoading());
  }
};

export const importCsvStorages = (data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    let response = await ContractRequests.importCsvStorages(data);
    if (callback && typeof callback === "function") {
      callback();
    }
    return response;
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const registerDebtLetterBatch = (data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    let response = await ContractRequests.registerDebtLetterBatch(data);
    if (callback && typeof callback === "function") {
      callback();
    }
    return response;
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const cancelInstallments = data => async dispatch => {
  dispatch(addLoading());
  try {
    let response = await ContractRequests.cancelInstallments(data);
    return response;
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateContractId = (data, callback) => async () => {
  try {
    await ContractRequests.updateContractId(data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  }
};

export const updateContractStatus = (data, callback) => async () => {
  try {
    await ContractRequests.updateContractStatus(data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  }
};

export const fetchContractKobana = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await ContractRequests.fetchContractKobana(params);
    dispatch({ type: ACTION_SAVE_CONTRACTS_CONSOLIDATED, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchContractPDF = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await ContractRequests.fetchContractPDF(params);
    dispatch({ type: ACTION_STATUS_PDF, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const downloadSettlementLetter = body => async dispatch => {
  dispatch(addLoading());
  let blobUrl = null;
  try {
    const response = await ContractRequests.downloadSettlementLetter({
      contractId: body.contractId,
      debtClearanceDate: body.debtClearanceDate,
    });
    const blob = base64ToBlob(response, "application/pdf");
    blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute(
      "download",
      `carta-quitacao-${body.contractExternalId}.pdf`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    if (blobUrl) {
      window.URL.revokeObjectURL(blobUrl);
    }
    dispatch(removeLoading());
  }
};

export const getDebtClearanceLetterFile =
  debitLetterFileId => async dispatch => {
    dispatch(addLoading());
    let blobUrl = null;
    try {
      const response =
        await ContractRequests.getDebtClearanceLetterFile(debitLetterFileId);
      const blob = base64ToBlob(response, "application/pdf");
      blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `carta-quitacao-${debitLetterFileId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      message.success("Carta de quitação baixada com sucesso!");
    } catch (err) {
      handleGenericApiError(err);
      message.error("Erro ao baixar carta de quitação");
    } finally {
      if (blobUrl) {
        window.URL.revokeObjectURL(blobUrl);
      }
      dispatch(removeLoading());
    }
  };

export const getExactAmount = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await ContractRequests.getExactAmount(params);
    return data;
  } catch (err) {
    handleGenericApiError(err);
    return null;
  } finally {
    dispatch(removeLoading());
  }
};

export const checkInstallmentDependencies =
  (contractId, installmentNumbers) => async () => {
    try {
      const data = await ContractRequests.checkInstallmentDependencies(
        contractId,
        installmentNumbers
      );
      return data;
    } catch (err) {
      handleGenericApiError(err);
      return null;
    }
  };

export const fetchContractIdByExternalId =
  contractExternalId => async dispatch => {
    dispatch(addLoading());

    try {
      const data =
        await ContractRequests.fetchContractIdByExternalId(contractExternalId);
      return data;
    } catch (err) {
      handleGenericApiError(err);

      return null;
    } finally {
      dispatch(removeLoading());
    }
  };

export const sendNotificationToInsurance = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await ContractRequests.sendNotificationToInsurance(params);
    message.success("Notificação enviada para seguradora");
    return data;
  } catch (err) {
    handleGenericApiError(err);
    return null;
  } finally {
    dispatch(removeLoading());
  }
};
